var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup12211(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 183,
    viewBox: "0 0 885 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_43_48569)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6782,
    y: 4.67821,
    width: 853.644,
    height: 125.644,
    rx: 11.8961,
    stroke: "#EBEBEB",
    strokeWidth: 2.64359
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_48569",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 851,
    height: 123
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_48569)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_43_48569)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.515,
    cy: 118.297,
    rx: 127.515,
    ry: 118.297,
    transform: "matrix(-1 0 0 1 978.254 -13.9722)",
    fill: "#FE8616"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_43_48569)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8162,
    cy: 68.3664,
    rx: 76.8162,
    ry: 68.3664,
    transform: "matrix(-1 0 0 1 761.632 61.3076)",
    fill: "#F9D411"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M851.382 136.34H818.678L834.036 49.6125C831.145 54.3102 825.845 58.8273 818.136 63.1636C810.427 67.5 802.357 69.6682 793.925 69.6682L791.576 39.3137C802.899 39.3137 813.499 35.8807 823.376 29.0149C833.253 22.0285 839.336 14.4399 841.625 6.249H874.148L851.382 136.34Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_43_48569",
    x: 0.529495,
    y: 0.283766,
    width: 883.941,
    height: 182.059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.53632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_48569"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.21795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_43_48569",
    result: "effect2_dropShadow_43_48569"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.9722
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1453
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_43_48569",
    result: "effect3_dropShadow_43_48569"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36.8718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.91346
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_43_48569",
    result: "effect4_dropShadow_43_48569"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_43_48569",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_43_48569",
    x: 538.865,
    y: -198.331,
    width: 623.748,
    height: 605.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48569"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_43_48569",
    x: 423.641,
    y: -123.051,
    width: 522.35,
    height: 505.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48569"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12211);
export default __webpack_public_path__ + "static/media/Group1221(1).8d5ba421a10fe00ab1d72f4cb257d971.svg";
export { ForwardRef as ReactComponent };